import { processingStatus, processingStatusOptions } from '../../../Models/Enums';

export interface SearchRequestStatusBoxProps {
    status?: processingStatus;
}

export function getProcessingStatusDisplayName(status?: processingStatus) {

	switch (status) {
		case 'CREATED':
			return 'Requested';
		case 'PROCESSING':
			return 'Generating';
		case 'PROCESSED':
			return 'Completed';
		case 'ERROR':
			return 'Error';
		default:
			return processingStatusOptions[status ?? 'ERROR'];
	}
}

const SearchRequestStatusBox = (props: SearchRequestStatusBoxProps) => {
	const { status } = props;
	const actualStatus = status ?? 'ERROR';

	return (
		<div>
			<span className={`status-box ${actualStatus}`}>
				{getProcessingStatusDisplayName(actualStatus)}
			</span>
		</div>
	);
};

export default SearchRequestStatusBox;